<template>
  <!-- eslint-disable max-len -->
  <div class="root">
    <!-- Debug UI follows -->
    <!-- <div style="position: fixed; left: 10px; top: 10px; width: 200px; min-height: 80px; background-color: red; margin: auto;">{{ useCodeSignIn || 'nothing' }}<br/>{{registrationLinkObject || 'no reg link object loaded'}}</div> -->
    <div v-if="loading || (useCodeSignIn && shouldAutoSignIn) && !me">
      <blade-spinner />
    </div>
    <div v-else class="content">
      <div class="login-card mobile-adjust">
        <div class="login-card-background" :style="leftPanelBackgroundStyle" />
        <div class="login-form-container" @keydown="listenForEnter">
          <div class="login-title form-element">{{forgotPassword ? 'reset password' : loginHeader}}</div>
          <template v-if="useCodeSignIn">
            <input v-model.trim="loginUniqueId" :validator="$v.loginUniqueId" v-focus autofocus class="form-control form-element" :placeholder="loginCodePlaceholder" @input="allowValidationErrors=true" @blur="()=>{if (allowValidationErrors) $v.loginUniqueId.$touch()}" ref="loginUniqueId" />
          </template>
          <template v-else>
            <input v-model.trim="email" :validator="$v.email" v-focus autofocus type="email" name="email" class="form-control form-element" placeholder="Email" @input="allowValidationErrors=true" @blur="()=>{if (allowValidationErrors) $v.email.$touch()}" ref="email" />
            <input v-if="!forgotPassword" v-model.trim="password" :validator="$v.password" type="password" class="form-control form-element" placeholder="Password" @input="allowValidationErrors=true" @blur="()=>{if (allowValidationErrors) $v.password.$touch()}" ref="password" />
          </template>

          <div class="login-form-footer">
            <div class="form-element">
              <a href="#" v-if="!useCodeSignIn"
                @click.prevent="toggleForgotPassword">
                {{forgotPassword ? 'back to login' : 'Forgot password?'}}
              </a>
              <p v-if="!useCodeSignIn && (classId || code || registrationLink) && !forgotPassword">
                Need an account? <router-link :to="signUpUrl" style="color: rgb(80, 80, 80);">Sign up here.</router-link>
              </p>
            </div>
            <div class="login-form-login-button-container form-element">
              <button
                v-if="forgotPassword"
                type="submit"
                class="btn pw-reset-btn lgn-lg-btn"
                @click.prevent="onSubmit"
                :disabled="$v.$invalid">
                request password reset
              </button>
              <button
                v-else
                type="submit"
                class="btn login-btn lgn-lg-btn"
                @click.prevent="onSubmit"
                :disabled="$v.$invalid">
                Login
              </button>
            </div>
          </div>
          <div class="error-container">
            <template v-if="$v.code && $v.code.$error">
              <p class="error-msg" v-if="!$v.code.required">Login code is required</p>
            </template>

            <template v-if="$v.email && $v.email.$error">
              <p class="error-msg" v-if="!$v.email.required">Email is required</p>
              <p class="error-msg" v-else-if="!$v.email.email">Email must be a valid email</p>
              <p class="error-msg" v-else-if="!$v.email.maxLength">Email must be {{ $v.email.$params.maxLength.max }} characters or less</p>
            </template>

            <template v-else-if="$v.password && $v.password.$error">
              <p class="error-msg" v-if="!$v.password.required">Password is required</p>
              <p class="error-msg" v-else-if="!$v.password.minLength">Password must be {{ $v.password.$params.minLength.min }} characters or more</p>
              <p class="error-msg" v-else-if="!$v.password.maxLength">Password must be {{ $v.password.$params.maxLength.max }} characters or less</p>
            </template>
          </div>
        </div>
      </div>
      <div class="login-card">
        <div class="login-card-background" :style="rightPanelBackgroundStyle" />
        <div class="login-brand-container">
          <div class="brand-top">
            <div class="brand-image" :style="`background-image: url('${brandImage}');`" />
          </div>
          <div style="border: 1px solid white;"/>
          <div class="brand-bottom" v-html="brandText"/>
        </div>
      </div>
    </div>
    <eula-prompt class="eula-prompt-container" v-if="showEULA" @noaccept="() => { showEULA = false; submitted = false; }"/>
  </div>
</template>

<script>
import { required, email as isEmail, minLength, maxLength } from 'vuelidate/lib/validators';
import { mapActions, mapGetters, mapMutations } from 'vuex';

import EulaPrompt from '@/components/ui/modals/EULAPrompt';
import catalogPurchaseTarget from '../../utils/catalog';

export default {
  components: {
    EulaPrompt
  },
  props: {
    registrationLink: String,
    classId: String,
    // This is the code for the sign in screen
    code: String,
    role: String
  },
  data() {
    return {
      loading: false,
      codeSigninReactivityFix: 0,
      unwatch: null,
      allowValidationErrors: false,
      password: '',
      // This is the code that replaces email/password for certain clients
      loginUniqueId: '',
      email: '',
      submitted: false,
      showEULA: false,
      forgotPassword: false,
      showNotVerifiedPrompt: false,
      requestVerificationEmailRecipient: '',
      registrationLinkObject: null
    };
  },
  created() {
    // Note: This is a gross hack but it literally does not matter
    // This is all set by signup
    if (!window.preventSignupEmailConsumption) {
      const value = localStorage.getItem('signup-used-email');
      if (value) {
        localStorage.removeItem('signup-used-email');
        this.email = value;
      }
    }

    if (this.role) {
      this.setSignInRole(this.role);
    }
    this.exitDemo();
    this.clearEmail();
  },
  async mounted() {
    if (this.me && this.me.email) {
      this.$router.replace(this.signUpUrl);
    }

    if (this.registrationLinkFiltered) {
      try {
        this.loading = true;
        const link = await this.getRegistrationLinkByLink(this.registrationLinkFiltered);
        this.$set(this, 'registrationLinkObject', link);
        if (link) {
          this.setRegistrationLinkUsedAtLogin(link);
        }
        console.log({ link });
        if (link.signInConfig) {
          await this.setActiveSignInConfig(link.signInConfig);
        } else {
          await this.getActiveSignInConfig();
        }
      } catch (err) {
        console.error(err);
      } finally {
        this.loading = false;
      }
    }

    if (this.shouldAutoSignIn) {
      await this.getActiveSignInConfig();
      this.codeSigninReactivityFix += 1;
      await this.$forceUpdate();
      if (this.useCodeSignIn) {
        this.loginUniqueId = this.anonymousIdParam;
        try {
          await this.onSubmit();
          return;
        } catch (err) {
          this.setAidParam(null);
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'activeEnvironment',
      'activeSignInConfig',
      'hasAnonymousIdParam',
      'anonymousIdParam',
      'me'
    ]),
    shouldAutoSignIn() {
      return this.hasAnonymousIdParam || (
        this.registrationLinkObject &&
        this.registrationLinkObject.uniqueIdSigninAutoRegister &&
        this.registrationLinkObject.uniqueIdSigninAutoGenerateCode
      );
    },
    registrationLinkFiltered() {
      return this.registrationLink && this.registrationLink.includes('&') ? this.registrationLink.split('&')[0] : this.registrationLink;
    },
    useCodeSignIn() {
      return ((this.activeSignInConfig && this.activeSignInConfig.uniqueIdSignin)
            || (this.registrationLinkObject && this.registrationLinkObject.uniqueIdSignin))
            && (this.codeSigninReactivityFix || !this.codeSigninReactivityFix);
    },
    loginHeader() {
      if (this.useCodeSignIn && this.registrationLinkObject && this.registrationLinkObject.uniqueIdLoginHeader) {
        return this.registrationLinkObject.uniqueIdLoginHeader;
      }
      return 'Login';
    },
    loginCodePlaceholder() {
      if (this.useCodeSignIn && this.registrationLinkObject && this.registrationLinkObject.uniqueIdLoginPlaceholder) {
        return this.registrationLinkObject.uniqueIdLoginPlaceholder;
      }
      return 'Login Code';
    },
    useAutogenAnonymousCodeSignIn() {
      return ((this.activeSignInConfig && this.activeSignInConfig.uniqueIdSignin && this.activeSignInConfig.uniqueIdSigninAutoRegister)

            || (this.registrationLinkObject
              && this.registrationLinkObject.uniqueIdSignin && this.registrationLinkObject.uniqueIdSigninAutoRegister))

            && (this.codeSigninReactivityFix || !this.codeSigninReactivityFix);
    },
    signUpUrl() {
      return this.$route.fullPath.replace('signin', 'signup');
    },
    leftPanelBackgroundStyle() {
      return {
        'background-color': this.activeSignInConfig.signinBackgroundColor
      };
    },
    rightPanelBackgroundStyle() {
      return {
        'background-color': this.activeSignInConfig.brandPrimaryColor
      };
    },
    brandImage() {
      return this.resolveAssetPath(this.activeSignInConfig.midsectionImage, 'ui/customer');
    },
    brandText() {
      return this.activeSignInConfig.midsectionText || 'RedmerU is a hosting platform for digital case studies also known as “gamulations” for academic use in higher education institutions. These applications provide an experiential learning experience for college students both in the classroom and from home in a distance learning environment.';
    }
  },
  methods: {
    ...mapMutations([
      'setSignInRole',
      'setActiveEnvironment',
      'setAidParam',
      'setRegistrationLinkUsedAtLogin'
    ]),
    ...mapActions([
      'login',
      'getRegistrationLinkByLink',
      'requestPasswordResetEmail',
      'requestVerificationEmail',
      'exitDemo',
      'clearEmail',
      'emailExists',
      'flashDanger',
      'flashPrimary',
      'getActiveEnvironment',
      'getActiveSignInConfig',
      'setActiveSignInConfig'
    ]),

    listenForEnter(evt) {
      if (this.$v.$invalid) return;

      /** @type {KeyboardEvent} */
      const ev = evt;
      if (ev.key === 'Enter') {
        this.onSubmit();
      }
    },

    // After a successful sign-in, route to the content catalog purchase page
    // when this registration link has content that hasn't been paid for yet;
    // otherwise go to the normal home location.
    async afterAuthRedirect() {
      const target = await catalogPurchaseTarget(
        this.$store, this.me, this.registrationLinkFiltered || undefined
      );
      if (target) {
        this.$router.replace(target);
        return;
      }
      this.$router.home();
    },

    async onSubmit() {
      if ((this.$v.$invalid && !this.hasAnonymousIdParam && !this.shouldAutoSignIn) || this.submitted) return;
      this.submitted = true;

      if (this.useCodeSignIn) {
        try {
          const { role, loginUniqueId, classId, forgotPassword, code, registrationLinkFiltered } = this;
          await this.login({ role, loginUniqueId, classId, forgotPassword, code, registrationLink: registrationLinkFiltered });
          await this.afterAuthRedirect();
        } catch (err) {
          console.error(err);

          let message = 'We couldn\'t log you in. Please ensure your login code is correct and try again.';
          // Rate limited
          if (err && err.response && err.response.status === 429) {
            message = 'Too many attempts to access this content in a short period of time. Please try again later.';
          }
          if (!err.response) {
            console.error(err);
          } else if (err.response.status === 403) {
            message = err.response.data;
            if (message.includes('verified')) {
              this.requestVerificationEmailRecipient = this.email;
              this.showNotVerifiedPrompt = true;
            }
          }
          this.flashDanger({ message, modal: true });
          this.submitted = false;
          this.$refs.loginUniqueId.focus();
        }
        return;
      }

      try {
        const { email } = this;
        await this.emailExists({ email });
      } catch (_) {
        const message = 'Email not found';
        this.flashDanger({ message, modal: true });
        this.clearEmail();
        this.submitted = false;
        this.$refs.email.focus();
        return;
      }

      try {
        const { role, email, password, classId, forgotPassword, code, registrationLink } = this;
        if (forgotPassword) {
          await this.requestPasswordResetEmail({ email });
          const message = 'Your request has been submitted. You should receive an email within a few minutes with instructions to reset your email.';
          this.flashPrimary({ message, modal: true });
          this.forgotPassword = false;
          this.email = '';
          this.password = '';
        } else {
          await this.login({ role, email, password, classId, code, registrationLink });
          if (this.me.eulaAccepted) {
            await this.afterAuthRedirect();
          } else {
            this.showEULA = true;
          }
        }
      } catch (err) {
        let message = 'We couldn\'t log you in, please check that email and password are correct and try again';
        // Rate limited
        if (err && err.response && err.response.status === 429) {
          message = 'Too many attempts to access this content in a short period of time. Please try again later.';
        }
        if (!err.response) {
          console.error(err);
        } else if (err.response.status === 403) {
          message = err.response.data;
          if (message.includes('verified')) {
            this.requestVerificationEmailRecipient = this.email;
            this.showNotVerifiedPrompt = true;
          }
        }
        this.flashDanger({ message, modal: true });
        this.submitted = false;
        this.$refs.password.focus();
      }
    },

    toggleForgotPassword() {
      this.forgotPassword = !(this.forgotPassword);
      if (this.forgotPassword) {
        this.password = 'aaaaaaa';
      } else {
        this.password = '';
      }
    },

    async requestVerification() {
      const { requestVerificationEmailRecipient } = this;
      if (requestVerificationEmailRecipient == null || this.submitted) return;
      this.submitted = true;

      try {
        await this.emailExists({ email: requestVerificationEmailRecipient });
      } catch (_) {
        const message = 'Email not found';
        this.flashDanger({ message, modal: true });
        this.clearEmail();
        this.submitted = false;
        this.showNotVerifiedPrompt = false;
        this.$refs.email.focus();
        return;
      }

      try {
        await this.requestVerificationEmail({ email: requestVerificationEmailRecipient });
        this.flashPrimary({
          message: `A new email was sent to ${
            requestVerificationEmailRecipient} with a verification link. Click that link to verify your email and then you can log in.`,
          modal: true,
        });
        this.submitted = false;
      } catch (_) {
        const message = `Request for new verification email to ${requestVerificationEmailRecipient} failed.`;
        this.flashDanger({ message, modal: true });
        this.submitted = false;
      }
    },
  },
  validations() {
    if (this.useCodeSignIn) {
      return {
        loginUniqueId: {
          required
        },
      };
    }
    return {
      email: {
        required,
        email: isEmail,
        maxLength: maxLength(254)
      },
      password: {
        required,
        minLength: minLength(6),
        maxLength: maxLength(128)
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.loader {
  border: 4px solid #f3f3f3aa;
  border-top: 4px solid #44484baa;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  margin: auto;
  animation: spin .75s cubic-bezier(0.455, 0.03, 0.515, 0.955) infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.root {
  // 40px == the navbar height.  If that changes, change this.
  height: calc(100vh - 40px);
  background-size: cover;
  width: 100%;
  position: relative;
  // font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: 100;
}

.content {
  input {
    color: rgb(34, 34, 34);
  }
  // color: var(--signInTextColor);
  color: rgb(34,34,34);
  display: flex;
  flex-flow: row wrap;
  justify-content: center;
  align-items: center;

  height: 45%;
  width: 100%;
  // padding-left: 22%;
  // padding-right: 22%;
  position: absolute;
  top: 15%;
}

.login-card {
  position: relative;
  min-width: calc(min(350px, 98vw));
  min-height: 450px;
  margin: 10px;
  width: 25%;
  height: 100%;
  border-radius: 15px;
  border: 2px solid white;
  overflow: hidden;
}

@media only screen and (max-width: 757px)  {
  .login-card.mobile-adjust {
    min-height: 0 !important;
    height: fit-content !important;
  }
}

.login-card-background {
  position: absolute;
  top: 0px;
  right: 0px;
  left: 0px;
  bottom: 0px;

  background-color: white;
  mask-image: url('/static/ui/customer/EA1_loginBox-White.png');
  mask-size: 110% 110%;
  mask-position: center;
}

.login-form-container
{
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: flex-end;
  padding: 20px;
  overflow-y: auto;
}

.login-form-footer
{
  display: flex;
  justify-content: space-between;
}

.login-form-login-button-container
{
  display: flex;
  justify-content: flex-end;
}

.login-brand-container
{
  position: relative;
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 20px;
  overflow-y: auto;
  color: white;
}

.brand-top
{
  height: 48%;
}

.brand-bottom
{
  height: 48%;
  font-size: 18px;
}

.brand-image
{
  position: relative;
  width: 100%;
  height: 100%;
  padding: 30px;
  background-origin: content-box;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.lgn-lg-btn
{
  font-size: 18px;
  min-width: 100px;
  height: 40px;
  padding: 5px;
}

.login-title
{
  font-size: 30px;
  text-transform: uppercase;
  font-weight: 50;
  color: var(--signInTitleColor) !important;
}

.form-element
{
  margin-bottom: 5px;
}

.error-container
{
  margin-top: 5px;
  height: 20px;
}

.error-msg
{
  color: darkred;
  font-weight: 500;
}

.brand-bottom
{
  color: var(--signInTextColor);
}

.eula-prompt-container
{
  position: fixed;
  top: calc(20vh - 15px);
}
</style>



// WEBPACK FOOTER //
// src/components/auth/Signin.vue